export interface IBugReportItem {}

export default function BugReportItem() {
  return (
    <div className="p-5">
      Noticed a bug? Have some feedback?{" "}
      <span className="underline hover:text-brij-Blue">
        <a target="_blank" rel="noopener noreferrer" href="https://brijedu.notion.site/Brij-FAQ-Support-d7b3ad4f90334b319264e4da747db349">
          Click Here
        </a>
      </span>
    </div>
  );
}
